/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { BA_ACTION, ENTITYNAME, LOCALSTORAGE_KEY, SYNOPSIS_TYPE } from "../../framework/constant/constant";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import LanguageTranslator from "../../components/LanguageTranslator";
import BossAssistantIcon from "./component/BossAssistantIcon";
import { utility } from "../../framework/utility/utilityProvider";
import { EnumCell } from "../../framework/forms/helpercomponents/CustomGridCells/EnumCell";

function MediaEpisodeSynopsisEditForm(props) {

  const [dataItem, setDataItem] = useState({
    Synopsis: "",
    Language: "",
    Type: SYNOPSIS_TYPE.Long
  });
  const [editMode, setEditMode] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [showTranslateForm, setShowTranslateForm] = useState(false);
  const lang = useTranslation();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const selectedIndexRef = useRef(0);
  const setSelectedIndexRef = (data) => {
    selectedIndexRef.current = data;
  }
  const [synopsisTypes, setSynopsisTypes] = useState([]);

  useEffect(() => {
    loadCombo();
  }, [])

  const loadCombo = async () => {
    let langRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(langRes.data);
    if (langRes.data?.length > 0) {
      setDataItem({ ...dataItem, Language: langRes.data[0] });
    }
    let typeRes = Object.keys(SYNOPSIS_TYPE).map((x) => {
      return {
        _id: SYNOPSIS_TYPE[x],
        Description: x
      }
    })
    setSynopsisTypes(typeRes);

    const longType = typeRes.find((t) => t._id === SYNOPSIS_TYPE.Long);
    setDataItem((prev) => ({
      ...prev,
      Type: longType || {},
    }));
  }

  const onChange = (e) => {
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  };

  const isValidforadd = () => {
    if (dataItem.Synopsis == "" || dataItem.Synopsis == undefined) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.synopsis_can_not_be_null_media_episode_Synopsis_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return false;
    }
    if (dataItem.Language == undefined || Object.keys(dataItem.Language).length == 0) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.please_select_language_media_episode_Synopsis_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return false;
    }
    return true;
  }

  const addSynopsis = (index) => {
    if (isValidforadd()) {
      const synopsisObject = {
        ...dataItem,
        Language: typeof dataItem.Language === "string" ? JSON.parse(dataItem.Language) : dataItem.Language,
        Type: dataItem?.Type?._id
      }
      //add validation
      props.setSynopsisData([...props.data, synopsisObject]);
      setDataItem({ Synopsis: '', Type: {} });
      clearData();
    }
  }
  const MyCommandCell = (props) => (
    <div style={{ display: "flex" }}>
      <EditRoundButton onClick={() => editFormGrid(props)} />
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeSynopsis(props.dataIndex), () => { })} />
    </div>
  )

  const editFormGrid = (data) => {
    let editDataItem = { ...data.dataItem, Type: synopsisTypes.find((t) => t._id === data.dataItem?.Type) };
    setSelectedIndexRef(data.dataIndex);
    setDataItem(editDataItem);
    setToggle(true);
    setEditMode(true);
  };


  const removeSynopsis = (index) => {
    props.setSynopsisData([
      ...props.data.slice(0, index),
      ...props.data.slice(index + 1, props.data.length)
    ]);
    clearData();
    toast.success(`${lang.delete_successfully_grid_data_success_toast_message}`, {
      position: toast.POSITION.TOP_RIGHT
    });
  }

  const editSynopsis = () => {
    if (isValidforadd()) {
      let local = [...props.data];
      let newDataItem = { ...dataItem, Type: dataItem?.Type?._id };
      local[selectedIndexRef.current] = newDataItem;
      props.setSynopsisData(local);
      setEditMode(false);
      clearData();
    }
  }

  const clearData = () => {
    const defaultType = synopsisTypes.find((t) => t._id === SYNOPSIS_TYPE.Long);
    setDataItem({ Synopsis: '', Language: '', Type: defaultType ?? {} });
    setEditMode(false);
    setToggle(false);
  };

  const handleLangugaeTranslate = (data) => {
    console.log(data);
    setDataItem({ ...dataItem, Synopsis: data });
    setShowTranslateForm(false);
  }

  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.Synopsis, item, props.mediaData);
    console.log(aiDataRes);
    return aiDataRes;

  }

  const removeDuplicateFromArray = (field, arr) => {

    let uniqueItems = [];

    arr.map((x) => {
      if (!uniqueItems.includes(x[field])) {
        uniqueItems.push(x[field]);
      }
    })
    return uniqueItems;

  }

  const setSynopsisData = (newData) => {

    console.log("HERE IN MEDIA EPISODE SYNOPSIS")
    // console.log(newData);

    //CREATE SYNOPSIS DATA
    let newSynopsysData = [];
    newData.forEach((item) => {

      let language = languages.find((x) => x.Description == item.Language.Description);

      newSynopsysData.push({
        Language: { _id: language._id, SID: language.SID, Description: language.Description, ISOCode: language?.ISOCode, GoogleApiCode: language?.GoogleApiCode },
        Synopsis: item.Synopsis,
        Type: SYNOPSIS_TYPE.Long
      });

    });


    let tempData = [...newSynopsysData, ...props.data];
    let uniqueData = [];

    tempData.map((x) => {
      let found = uniqueData.find((y) =>
        y.Language.Description.toLowerCase() === x.Language.Description.toLowerCase()
      );
      // let found = uniqueData.find((y) => y.Language.Description.toLowerCase() == x.Language.Description.toLowerCase());
      if (!found) {
        uniqueData.push(x);
      }
    })

    props.setSynopsisData(uniqueData);
    // props.setSynopsisData([...props.data, ...newSynopsysData]);

  }

  return (<>
    <div className="row">
      {!toggle && <div className="col-12">
        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>

          <div><AddRoundButton onClick={() => setToggle(true)} /></div>
          <BossAssistantIcon
            style={{}}
            mediaEpisodeEntity={props.mediaData}
            iconSize={"35px"}
            onDataLoad={onBossAIMetaDataLoad}
            popupTtle={"Generate Synopsis"}
            tooltip={"Generate Synopsis with Boss AI"}
            description={"BOSS AI Generating Synopsis"}
            setMetaData={setSynopsisData}
            showLanguage={true}
          />

        </div>

        <Grid data={props.data} style={{ height: "30vh" }}>
          <GridColumn cell={MyCommandCell} width={"70px"} locked={true} />
          <GridColumn field="Language.Description" title={lang.language_column} editable={false} />
          <GridColumn field="Synopsis" title={lang.synopsis_column} editable={false} />
          <GridColumn field="Type" title={lang.type_column} editable={false} cell={EnumCell} />
        </Grid>
      </div>}
      {toggle && <div className="col-6" style={{ paddingTop: "30px" }}>
        <Grid data={props.data} style={{ height: "30vh" }}>
          <GridColumn cell={MyCommandCell} width={"60px"} locked={true} />
          <GridColumn field="Language.Description" title={lang.language_column} editable={false} />
          <GridColumn field="Synopsis" title={lang.synopsis_column} editable={false} />
          <GridColumn field="Type" title={lang.type_column} editable={false} cell={EnumCell} />
        </Grid>
      </div>}
      {toggle && <div className="col-6">
        {!editMode && <AddRoundButton onClick={() => addSynopsis()} />}
        {editMode && <SaveRoundButton onClick={() => { editSynopsis() }} />}
        <CancelRoundButton onClick={clearData} />
        <div className="row ml-2" >
          <div className="col-12 mt-2" style={{ border: "groove 1px" }}>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="">{lang.synopsis_label} *</label>
                  <label className='float-right cursor-pointer' onClick={() => setShowTranslateForm(true)}><i className="fa-solid fa-language" aria-hidden="true"></i></label>
                  <textarea type="text" className="form-control form-control-sm"
                    name="Synopsis"
                    value={dataItem.Synopsis}
                    onChange={(e) => onChange(e)} required />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="TabView">{lang.language_label} *</label><br />
                  <DropDownList
                    style={{
                      backgroundColor: "white",
                    }}
                    data={languages}
                    name="Language"
                    textField="Description"
                    dataItemKey="_id"
                    value={dataItem.Language}
                    onChange={onChange}
                    validator={(value) => value ? "" : "Please select the value"}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="TabView">{lang.type_label} *</label><br />
                  <DropDownList
                    style={{ backgroundColor: "white" }}
                    data={synopsisTypes}
                    name="Type"
                    textField="Description"
                    dataItemKey="_id"
                    value={dataItem.Type}
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </div>
    {showTranslateForm && <LanguageTranslator onSubmit={handleLangugaeTranslate} cancelEdit={() => setShowTranslateForm(false)} />}
  </>
  )
}

export default MediaEpisodeSynopsisEditForm
